import { useState, useEffect } from 'react'
import Icons from 'assets/icons'
import Button from 'components/formElements/Button'
import DefaultSelect from 'components/formElements/DefaultSelect'
import AnimatedSpan from 'containers/animatedSpan/AnimatedSpan'
import { useDispatch, useSelector } from 'react-redux'
import { useRequest } from 'hooks/useRequest'
import { setProjects } from 'redux/features/projects/projectsSlice'
import { projectTypes, roleIds } from 'utils/Constants'
import useToast from 'hooks/useToast'
import { Dialog } from 'primereact/dialog'
import moment from 'moment'
import { getPermission } from 'utils/Auth'
import { setUsers } from 'redux/features/users/usersSlice'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Link, useNavigate } from 'react-router-dom'
import Spinner from 'components/loader/Spinner'
import Tooltip from 'components/tooltip/Tooltip'

const Projects = () => {
	const [filterOptions, setFilterOptions] = useState({ isArchive: false, searchString: '', email: null })
	const [createModal, setCreateModal] = useState({ open: false, project: {} })
	const [sort, setSort] = useState()
	const [accountManagers, setAccountManagers] = useState([])
	const { projects, users } = useSelector((state) => state)
	const { projectsData } = projects
	const { usersData } = users
	const [getProjects, getProjectsLoading] = useRequest()
	const [getTechnologies] = useRequest()
	const [technologies, setTechnologies] = useState()
	const [addProject] = useRequest()
	const { showToast } = useToast()
	const dispatch = useDispatch()
	const [getUsers] = useRequest()
	const navigate = useNavigate()
	const hasProjectsPermission = getPermission('Project.read')
	const [request] = useRequest()
	const [developers, setDevelopers] = useState([])

	useEffect(() => {
		if (!hasProjectsPermission) {
			navigate('/')
		}
	}, [hasProjectsPermission])

	if (!hasProjectsPermission) {
		return null
	}

	useEffect(() => {
		if (!createModal.open) {
			getProjects('/Project/GetAllProjects', { method: 'GET', params: { isArchive: filterOptions.isArchive } }).then(
				(res) => {
					if (res.data.ok) {
						dispatch(
							setProjects(
								res.data.result.map((p) => ({
									...p,
									projectRoles: p.projectRoles.filter(
										(r) =>
											!r.endDate ||
											(r.endDate &&
												moment(new Date(), 'YYYY-MM-DD').diff(moment(r.endDate).format('YYYY-MM-DD'), 'days') < 1)
									),
								}))
							)
						)
					}
				}
			)
			getTechnologies('/Technologies/GetAllTechnologies', {
				method: 'GET',
			}).then((res) => {
				if (res.data.ok) {
					setTechnologies(res.data.result)
				}
			})
		}
		getUsers('/Account/GetAllUsers', {
			method: 'GET',
		}).then((res) => {
			if (res.data.ok) {
				dispatch(setUsers(res.data.result))
			}
		})
		getUsers('/Account/GetAllUsers', {
			method: 'GET',
		}).then((res) => {
			if (res.data.ok) {
				setAccountManagers(res.data.result)
			}
		})
	}, [createModal, filterOptions.isArchive])

	useEffect(() => {
		request('/Developer/GetAllDevelopers', { method: 'GET' }).then((res) => {
			if (res.data.ok) {
				setDevelopers(
					res.data.result
						.sort((a, b) => a.fullName.localeCompare(b.fullName))
						.map((s) => ({
							label: s.fullName,
							value: s.id,
						}))
				)
			}
		})
	}, [])

	const handleAddProject = () => {
		if (!createModal?.project?.name) {
			showToast('Proje İsmini Girin', 'error')
		} else {
			addProject('/Project/AddProjects', {
				method: 'POST',
				data: { ...createModal.project, continuousReportTypes: [{ continuousReportType: "YOK" }] },
			}).then((res) => {
				if (res.data) {
					showToast('Proje Oluşturuldu', 'success')
					setCreateModal({ open: false, project: {} })
				}
			})
		}
	}
	const handleChnage = (e, name, array) => {
		if (name == 'isArchive') {
			setFilterOptions((prev) => ({ ...prev, [name]: e.value }))
		} else if (e == null || e.length == 0 || e.value == '') {
			setFilterOptions((prev) => ({ ...prev, [name]: null }))
		} else {
			if (array) {
				setFilterOptions((prev) => ({
					...prev,
					[name]: e && e != undefined ? e : e.length > 0 && e,
				}))
			} else {
				setFilterOptions((prev) => ({
					...prev,
					[name]: e.value && e.value != undefined ? e.value : e.length > 0 && e[0].value,
				}))
			}
		}

	}
	const handleSort = (e) => {
		setSort(e)
	}
	const filteredProjects = sort
		? [...projectsData]
			?.sort((a, b) =>
				sort.value == 1
					? moment(b.createdAt).valueOf() - moment(a.createdAt).valueOf()
					: moment(a.createdAt).valueOf() - moment(b.createdAt).valueOf()
			)
			?.filter((d) => {
				const keys = Object.keys(filterOptions)
				let rt = [true]
				if (keys.length > 0) {
					keys.forEach((k) => {
						if (filterOptions[k] != null) {
							if (k == 'searchString') {
								let uniName = (d.name + d.customerName).toLocaleLowerCase('tr')
								rt.push(uniName.includes(filterOptions[k].toLocaleLowerCase('tr')))
							} else if (k == 'am') {
								rt.push(d.projectRoles.filter(r => r.roleId == roleIds.accountManager).find((e) => filterOptions[k].map((e) => e.value).includes(e.userId)))
							} else if (k == 'pm') {
								rt.push(d.projectRoles.filter(r => r.roleId == roleIds.projectManager).find((e) => filterOptions[k].map((e) => e.value).includes(e.userId)))
							} else if (k == 'isArchive') {
								rt.push(true)
							} else {
								rt.push(d.id == filterOptions[k])
							}
						}
					})
				}
				return rt.every((r) => r)
			})
		: projectsData.filter((d) => {
			const keys = Object.keys(filterOptions)
			let rt = [true]
			if (keys.length > 0) {
				keys.forEach((k) => {
					if (filterOptions[k] != null) {
						if (k == 'searchString') {
							let uniName = (d.name + d.customerName).toLocaleLowerCase('tr')
							//console.log(uniName, filterOptions[k], "UNINAME");
							rt.push(uniName.match(filterOptions[k].toLocaleLowerCase('tr')))
						} else if (k == 'am') {
							rt.push(d.projectRoles.filter(r => r.roleId == roleIds.accountManager).find((e) => filterOptions[k].map((e) => e.value).includes(e.userId)))
						} else if (k == 'pm') {
							rt.push(d.projectRoles.filter(r => r.roleId == roleIds.projectManager).find((e) => filterOptions[k].map((e) => e.value).includes(e.userId)))
						} else if (k == 'isArchive') {
							rt.push(true)
						} else {
							rt.push(d.id == filterOptions[k])
						}
					}
				})
			}
			return rt.every((r) => r)
		})
	//let outsideBg = filteredProjects.filter((filt) => filt?.types.length == 1 && filt.types[0].type == 'Turnkey')
	let newFilteredProject = filteredProjects.map((filt) => {
		return {
			...filt,
			greenColor: filt.types.length < 3 && filt?.types[0]?.type == 'Turnkey' && filt.statuses != "Tamamlandı" || filt?.types[1]?.type == 'CR' ? 'greenColor' : '',
		}
	})

	return (
		<AnimatedSpan className='page-container d-flex flex-column'>
			{getProjectsLoading ? (
				<div className='d-flex w-100 justify-content-center'>
					<Spinner size={3} />
				</div>
			) : (
				<div className='row'>
					<DataTable
						stripedRows
						className='col-md-12 p-1'
						emptyMessage='Hiç Kayıt Bulunamadı'
						size='small'
						responsiveLayout='stack'
						dataKey='id'
						header={() => (
							<div className='d-flex justify-content-between gap-3'>
								<div className='row flex-1'>
									<div className='col-md-2 pl-0'>
										<span className='p-input-icon-left '>
											<i className='pi pi-search' />
											{filterOptions.searchString && <i className="pi pi-times" style={{cursor: 'pointer', right: '10px'}} onClick={() => setFilterOptions({ ...filterOptions, searchString: '' })} />}
											<input
												type='text'
												placeholder='Proje Adı'
												className='default-input pl-5 pr-4'
												value={filterOptions.searchString}
												name='searchString'
												onChange={(e) => handleChnage(e.target, 'searchString')}
											/>
										</span>

									</div>
									<div className='col-md-3'>
										<DefaultSelect
											handleChange={(e) =>
												handleChnage(
													e.map((p) => ({ ...p, name: 'am' })),
													'am',
													true
												)
											}
											placeholder='AM'
											isSearchable
											isMulti
											selectOptions={accountManagers.map((pt) => ({ label: `${pt.firstName} ${pt.lastName}`, value: pt.id }))}
										/>
									</div>
									<div className='col-md-3'>
										<DefaultSelect
											handleChange={(e) =>
												handleChnage(
													e.map((p) => ({ ...p, name: 'pm' })),
													'pm',
													true
												)
											}
											placeholder='PM'
											isSearchable
											isMulti
											selectOptions={usersData.map((pt) => ({ label: `${pt.firstName} ${pt.lastName}`, value: pt.id }))}
										/>
									</div>
									<div className='col-md-2'>
										<DefaultSelect
											handleChange={(e) => handleChnage({ ...e, name: 'isArchive' }, 'isArchive')}
											placeholder='Arşiv'
											value={[
												{ label: 'Arşiv(Evet)', value: true },
												{ label: 'Arşiv(Hayır)', value: false },
											].find((f) => f.value == filterOptions.isArchive)}
											selectOptions={[
												{ label: 'Arşiv(Evet)', value: true },
												{ label: 'Arşiv(Hayır)', value: false },
											]}
										/>
									</div>
									<div className='col-md-2'>
										<DefaultSelect
											placeholder='Sırala'
											value={sort}
											selectOptions={[
												{ label: 'Yeniden Eskiye', value: 1 },
												{ label: 'Eskiden Yeniye', value: 2 },
											]}
											handleChange={(e) => handleSort(e)}
											isClearable
										/>
									</div>
								</div>
								<div className='filters-right'>
									{getPermission('Project.create') && (
										<Button handleClick={() => setCreateModal({ open: true })} className='btn-success' title='Proje Oluştur' icon={<Icons.plus />} />
									)}
								</div>
							</div>
						)}
						rowClassName={`cursor-pointer table-hover `}
						rowExpansionTemplate={() => <div>Expansion</div>}
						onRowClick={(e) => {
							navigate(`${e.data.id}`)
						}}
						value={newFilteredProject}
					>
						<Column
							headerClassName='text-bold bg-primary text-default'
							className='text-semi-bold text-sm'
							style={{ maxWidth: '15%', width: '15%', position: 'relative', padding: '8px', }}
							field='name'
							header='Proje Adı'
							sortable='true'
							body={(rowData) => {
								//let bgSet = rowData.types.length == 1 && rowData.types[0].type == 'Turnkey' ? 'bggreen' : ''
								//let bgSet;
								// 	bgFilter?.forEach((bg) => {
								//            if(bg.name == rowData.name){
								// 			console.log('yes');
								// 			return (
								// 				<div className='bggreen'>
								// 					{rowData.customerName && `${rowData.customerName} -`} {rowData.name}
								// 				</div>
								// 			)
								// }

								// 	})
								//console.log(bgSet, "bgSETTT");

								return (
									<div className={`text-sm ${rowData.greenColor ? "cellSetGreen" : "cellSetTransparent"}`} id={rowData.greenColor}>
										<Tooltip textClass='bottom' text={rowData.customerName && `${rowData.customerName} - ${rowData.name}`} >
											<div className=' text-elipsis'>{rowData.customerName && `${rowData.customerName} - ${rowData.name}`} </div>
										</Tooltip>
									</div>
								)
							}}
						/>
						<Column
							headerClassName='text-bold bg-primary text-default'
							className='text-semi-bold text-sm'
							style={{ width: 'auto', position: 'relative', padding: '0px !important', margin: '0px !important' }}
							field='types'
							header='Proje Tipi'
							body={(rowData) => {
								return (
									<div className={`text-sm text-primary ${rowData.greenColor ? "cellSetGreen" : "cellSetTransparent"}`} id={rowData.greenColor} >
										{rowData.types.length > 0 ? rowData.statuses == "Tamamlandı" ? "" : rowData.types.map((p) => p.type.toUpperCase())?.join(', ') : 'Proje Tipi Belirlenmemiş'}
									</div>
								)
							}}
						/>
						<Column
							headerClassName='text-bold bg-primary text-default'
							className='text-semi-bold  text-sm'
							field='projectRoles'
							header='AM'
							style={{ width: '15%' }}
							body={(rowData) => {
								return (
									<div className={`text-sm  ${rowData.greenColor ? "cellSetGreen" : "cellSetTransparent"}`} id={rowData.greenColor}>
										{rowData.projectRoles?.filter(r => r.roleId == roleIds.accountManager)?.map((r) => `${r.user.firstName} ${r.user.lastName}`).join(', ')}
									</div>
								)
							}}
						/>
						<Column
							headerClassName='text-bold bg-primary text-default'
							className='text-semi-bold  text-sm'
							field='projectRoles'
							header='PM'
							style={{ width: '15%' }}
							body={(rowData) => {
								return (
									<div className={`text-sm  ${rowData.greenColor ? "cellSetGreen" : "cellSetTransparent"}`} id={rowData.greenColor}>
										{rowData.projectRoles?.filter(r => r.roleId == roleIds.projectManager)?.map((r) => `${r.user.firstName} ${r.user.lastName}`).join(', ')}
									</div>
								)
							}}
						/>
						<Column
							headerClassName='text-bold bg-primary text-default'
							className='text-semi-bold text-sm'
							field='statuses'
							header='Durum'
							style={{ width: 'auto' }}
							body={(rowData) => {
								return (
									<div id={rowData.greenColor}
										className={`text-sm text-${rowData?.statuses && rowData?.statuses?.includes('Tamamlandı')
											? 'success'
											: rowData?.statuses?.includes('Bekle')
												? 'warning'
												: 'primary'
											} ${rowData.greenColor ? "cellSetGreen" : "cellSetTransparent"} `}

									>
										{rowData.statuses && rowData.statuses}
									</div>
								)
							}}
						/>
						<Column
							headerClassName='text-bold bg-primary text-default'
							className='text-semi-bold text-sm'
							field='alfa'
							header='Alfa Tarihi'
							sortable='true'
							style={{ width: 'auto' }}
							body={(rowData) => {
								return (
									<div className={`text-sm  ${rowData.greenColor ? "cellSetGreen" : "cellSetTransparent"}`} id={rowData.greenColor} >
										{rowData.alfa && moment(rowData.alfa).format('LL')}
									</div>
								)
							}}
						/>
						<Column
							headerClassName='text-bold bg-primary text-default'
							className='text-semi-bold text-sm'
							field='uat'
							header='UAT Tarihi'
							sortable='true'
							style={{ width: 'auto' }}
							body={(rowData) => {
								return (
									<div className={`text-sm  ${rowData.greenColor ? "cellSetGreen" : "cellSetTransparent"}`} id={rowData.greenColor} >
										{rowData.uat && moment(rowData.uat).format('LL')}
									</div>
								)

							}}
						/>
						<Column
							headerClassName='text-bold bg-primary text-default'
							className='text-semi-bold text-sm'
							field='live'
							header='Canlı Tarihi'
							sortable='true'
							style={{ width: 'auto' }}
							body={(rowData) => {
								return (
									<div className={`text-sm  ${rowData.greenColor ? "cellSetGreen" : "cellSetTransparent"}`} id={rowData.greenColor} >
										{rowData.live && moment(rowData.live).format('LL')}
									</div>
								)
							}}
						/>
						<Column
							headerClassName='text-bold bg-primary text-default'
							className='text-semi-bold text-sm'
							field='live'
							header='SLA Periyod'
							sortable='true'
							style={{ width: 'auto' }}
							body={(rowData) => {
								const slaType = rowData?.types?.find((t) => t.type === 'Sla')
								const expectedDate = slaType && rowData?.slaEnd && moment(rowData.slaEnd)
								const diff = expectedDate && moment(new Date(), 'YYYY-MM-DD').diff(expectedDate.format('YYYY-MM-DD'), 'days')
								return (
									<span id={rowData.greenColor} className={`projects-list-card-footer-period text-sm ${diff > 0 ? 'text-danger' : ''} ${rowData.greenColor ? "cellSetGreen" : "cellSetTransparent"}`}>
										{ slaType && (
											<>
												{rowData.slaStart && <span>{moment(rowData.slaStart).format('LL')} </span>}
												{(<span>-</span>)}
												{rowData.slaEnd && <span> {moment(rowData.slaEnd).format('LL')}</span>}
											</>
										)}
									</span>
								)
							}}
						/>
						<Column
							headerClassName='text-bold bg-primary text-default'
							className='text-semi-bold text-sm relative-cell'
							field='lastSLAType'
							header='Sla Tipi'
							sortable='true'
							style={{ width: '10rem' }}
							body={(rowData) => {
								return (
									<span className={`text-sm ${rowData.greenColor ? "cellSetGreen" : "cellSetTransparent"}`} id={rowData.greenColor}>
										<Link target='_blank' className='new-page-link-icon' to={`/projects/${rowData.id}`}>
											<span>Yeni Pencerede Aç</span>{' '}
											<span onClick={(e) => e.stopPropagation()}>
												<Icons.arrowRight onClick={(e) => e.stopPropagation()} />
											</span>
										</Link>
										{rowData?.types?.find((t) => t.type === 'Sla') && rowData.lastSLAType}
									</span>
								)
							}}
						/>
					</DataTable>
				</div>
			)}
			<Dialog
				style={{ width: '50%', height: '' }}
				header='Proje Oluştur'
				draggable={false}
				visible={createModal.open}
				onHide={() => setCreateModal({ open: false, project: {} })}
			>
				<div className='w-100'>
					<div className='w-100 d-flex flex-column gap-3'>
						<div className='row'>
							<div className='col-md-12'>
								<input
									className='default-input'
									type='text'
									placeholder='Müşteri / Şirket Adı'
									onChange={(e) => {
										setCreateModal((prev) => ({ ...prev, project: { ...prev.project, customerName: e.target.value } }))
									}}
								/>
							</div>
						</div>
						<div className='row'>
							<div className='col-md-12'>
								<input
									className='default-input'
									type='text'
									placeholder='Proje Başlığı'
									onChange={(e) => {
										setCreateModal((prev) => ({ ...prev, project: { ...prev.project, name: e.target.value } }))
									}}
								/>
							</div>
						</div>
						<div className='row'>
							<div className='col-md-12'>
								<DefaultSelect
									isMulti
									handleChange={(e) => {
										setCreateModal((prev) => ({ ...prev, project: { ...prev.project, types: e.map((t) => ({ type: t.value })) } }))
									}}
									placeholder='Proje Tipi'
									selectOptions={projectTypes.map((pt) => ({ label: pt.type.toUpperCase(), value: pt.type }))}
								/>
							</div>
						</div>
						<div className='row'>
							<div className='col-md-12'>
								<DefaultSelect
									isMulti
									handleChange={(e) => {
										setCreateModal((prev) => ({
											...prev,
											project: { ...prev.project, projectTechnologies: e.map((t) => ({ technologyId: t.value })) },
										}))
									}}
									placeholder='Teknolojiler'
									selectOptions={technologies?.map((pt) => ({ label: pt.name, value: pt.id }))}
								/>
							</div>
						</div>
						<div className='row'>
							<div className='col-md-12'>
								<DefaultSelect
									isClearable
									isSearchable
									isMulti
									handleChange={(e) => {
										setCreateModal((prev) => ({
											...prev,
											project: { ...prev.project, projectDevelopers: e.map((t) => ({ developerId: t.value })) },
										}))
									}}
									placeholder='Geliştiriciler'
									selectOptions={developers}
								/>
							</div>
						</div>
						<div className='row'>
							<div className='col-md-12'>
								<input
									className='default-input'
									type='text'
									placeholder='DoneDone Id'
									onChange={(e) => {
										setCreateModal((prev) => ({ ...prev, project: { ...prev.project, doneDoneId: e.target.value } }))
									}}
								/>
							</div>
						</div>
						<div className='row'>
							<div className='col-md-12'>
								<input
									className='default-input'
									type='text'
									placeholder='Jira Id'
									onChange={(e) => {
										setCreateModal((prev) => ({ ...prev, project: { ...prev.project, jiraId: e.target.value } }))
									}}
								/>
							</div>
						</div>
						<div className='row'>
							<div className='col-md-12'>
								<input
									className='default-input'
									type='text'
									placeholder='Jira Key'
									onChange={(e) => {
										setCreateModal((prev) => ({ ...prev, project: { ...prev.project, jiraKey: e.target.value } }))
									}}
								/>
							</div>
						</div>
						<div className='row'>
							<div className='col-md-12 d-flex justify-content-end gap-3'>
								<Button className='btn-danger' title='Vazgeç' handleClick={() => setCreateModal({ open: false, project: {} })} />
								<Button className='btn-success' title='Kaydet' handleClick={handleAddProject} />
							</div>
						</div>
					</div>
				</div>
			</Dialog>
		</AnimatedSpan>
	)
}
export default Projects
